import {
  CLONE_AUDIENCE_REQUEST,
  CLONE_AUDIENCE_SUCCESS,
  CLONE_AUDIENCE_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const cloneAudience = (state = initialState, action) => {
  const types = {
    [CLONE_AUDIENCE_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [CLONE_AUDIENCE_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [CLONE_AUDIENCE_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default cloneAudience;
